import { defineComponent as _defineComponent } from 'vue'
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { computed, PropType } from 'vue';
import { BcxFormField } from '@/models/BcxForm';
import useI18n from '@/mixins/useI18n';
import useAddressTools from '@/mixins/useAddressTools';
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAddressDataEditor',
  props: {
  type: {
    type: String as PropType<'sender' | 'recipient'>,
    required: true,
  },
  addressData: {
    type: Object as PropType<any>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n();

const { countries } = useAddressTools();

const addressDataVM = useVModel(props, 'addressData');

const fields = computed(() => {
  const baseFields: BcxFormField[] = [
    {
      name: 'company',
      width: '100%',
      type: 'text',
      required: true,
      label: `${t('invoice.address-data.form.company')}`
    },
    {
      name: 'salutation',
      width: '33%',
      type: 'text',
      label: `${t('invoice.address-data.form.salutation')}`
    },
    {
      name: 'firstName',
      width: '67%',
      type: 'text',
      label: `${t('invoice.address-data.form.firstName')}`
    },
    {
      name: 'lastName',
      width: '100%',
      type: 'text',
      label: `${t('invoice.address-data.form.lastName')}`
    },
    {
      name: 'street',
      width: '75%',
      type: 'text',
      label: `${t('invoice.address-data.form.street')}`
    },
    {
      name: 'nr',
      width: '25%',
      type: 'text',
      label: `${t('invoice.address-data.form.nr')}`
    },
    {
      name: 'zip',
      width: '33%',
      type: 'text',
      label: `${t('invoice.address-data.form.zip')}`
    },
    {
      name: 'city',
      width: '67%',
      type: 'text',
      label: `${t('invoice.address-data.form.city')}`
    },
    {
      name: 'country',
      width: '100%',
      type: 'select',
      options: countries.value,
      label: `${t('invoice.address-data.form.country')}`
    }
  ];
  const senderFields: BcxFormField[] = [
    {
      name: 'phone',
      width: '100%',
      type: 'text',
      label: `${t('invoice.address-data.form.phone')}`
    },
    {
      name: 'hrb',
      width: '100%',
      type: 'text',
      label: `${t('invoice.address-data.form.hrb')}`
    },
    {
      name: 'court',
      width: '100%',
      type: 'text',
      label: `${t('invoice.address-data.form.court')}`
    },
  ];
  const recipientFields: BcxFormField[] = [
    {
      name: 'addition',
      width: '100%',
      type: 'text',
      label: `${t('invoice.address-data.form.addition')}`
    },
  ];
  return [
    ...baseFields,
    ...(props.type === 'sender' ? senderFields : recipientFields)
  ];
});


return { __sfc: true,props, t, countries, addressDataVM, fields, BCXForm }
}

})